import { Link } from '@remix-run/react'
import headshot from './joel353x326.jpg'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			{/* TODO: Add Meta */}
			{/* <Helmet
        title="Joel Steele"
        meta={[
          {
            name: "description",
            content: "Hi, I'm Joel. I'm here to help with your insurance.",
          },
          {
            name: "keywords",
            content: "Joel Steele",
          },
        ]}
      /> */}
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/about-us/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				About Us
			</Link>
			<br />
			<br />
			<h1 className="text-4xl font-black">Joel Steele</h1>
			<span className="image">
				<img src={headshot} alt="Joel Steele" className="max-w-md rounded-lg" />
			</span>
			<br />
			<br />
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<a
					href="https://calendly.com/joel-steele"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 underline"
				>
					schedule an appointment with Joel (opens in a new tab)
				</a>
			</p>
		</main>
	)
}
